var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPoi24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.9297 4.00006 9.8789 4.29291 8.95653 4.8482C8.03416 5.4035 7.2738 6.20102 6.75428 7.15808C6.23476 8.11514 5.97499 9.19691 6.0019 10.2912C6.02881 11.3856 6.34142 12.4526 6.90733 13.3817L12 21L17.0927 13.3817C17.6586 12.4526 17.9712 11.3856 17.9981 10.2912C18.025 9.19691 17.7652 8.11514 17.2457 7.15808C16.7262 6.20102 15.9658 5.4035 15.0435 4.8482C14.1211 4.29291 13.0703 4.00006 12 4V4ZM12 12.3942C11.5635 12.3942 11.1368 12.2618 10.7739 12.0138C10.4109 11.7657 10.128 11.4132 9.96099 11.0007C9.79395 10.5883 9.75024 10.1344 9.8354 9.69656C9.92056 9.25869 10.1308 8.85649 10.4394 8.5408C10.7481 8.22512 11.1413 8.01014 11.5694 7.92304C11.9976 7.83594 12.4413 7.88065 12.8446 8.05149C13.2479 8.22234 13.5926 8.51166 13.8351 8.88286C14.0776 9.25407 14.207 9.69049 14.207 10.1369C14.207 10.7356 13.9745 11.3097 13.5606 11.7331C13.1467 12.1564 12.5853 12.3942 12 12.3942Z",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPoi24);
export default __webpack_public_path__ + "static/media/ico-poi-24.5ff86ac9.svg";
export { ForwardRef as ReactComponent };